// Resultado de un borrado (clientes, proveedores): qué filas sacar de la lista y qué aviso mostrar.
//
// El backend responde 200 si borró todo, o 422 con `data.deleted` y el motivo cuando algún
// registro está protegido (un cliente con ventas o proformas). El helper de httpRequest devuelve
// `{status: 404}` si la petición falló. Antes las pantallas comprobaban `if (response.status)`,
// que también es verdadero para 404 y 422: mostraban «Cliente eliminado» y quitaban la fila
// aunque el cliente seguía en la base.
export function deleteOutcome(response, requestedIds, labels) {
    const status = response ? response.status : undefined;
    const data = (response && response.data) || {};
    const reported = Array.isArray(data.deleted) ? data.deleted : null;
    if (status === 200) {
        return {
            deletedIds: reported || requestedIds,
            toast: { severity: 'success', summary: 'Éxito', detail: labels.success, life: 3000 },
        };
    }
    return {
        deletedIds: reported || [],
        toast: {
            severity: 'error', summary: 'No se pudo eliminar',
            detail: (response && response.error) || labels.failure, life: 8000,
        },
    };
}
